export default __webpack_public_path__ + "static/poapart-62f0ab627cc105d84343636cee793278.jpeg";